import { gsap } from "gsap";
import { ScrollTrigger, DrawSVGPlugin } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(DrawSVGPlugin) ;

class SmvIcon extends HTMLElement {

  constructor() {
    super();
  }


  connectedCallback() {
    const svg = this.querySelector('svg');
    if (!svg) return;

    const firstLevel = Array.from(svg.children);
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this,
        start: 'top 85%',
        delay: 0.6,
      }
    });
    const stagger = 0.15;

    firstLevel.forEach((el, i) => {
      const pos = i * stagger;

      if (el.tagName.toLowerCase() === 'g') {
        const targets = el.querySelectorAll('path, polygon, circle, line, rect, ellipse, polyline');
        if (targets.length) {
          tl.fromTo(targets,
            { drawSVG: '0%' },
            {
              drawSVG: '100%',
              duration: 0.8,
              ease: 'power2.inOut',
              // onComplete: function () {
              //   gsap.set(targets, { clearProps: "strokeDasharray, strokeDashoffset" });
              // }
            },
            pos
          );
        }
      } else {
        tl.fromTo(el,
          { drawSVG: '0%' },
          {
            drawSVG: '100%',
            duration: 0.8,
            ease: 'power2.inOut',
            // onComplete: function () {
            //   gsap.set(el, { clearProps: "strokeDasharray, strokeDashoffset" });
            // }
          },
          pos
        );
      }
    });
  }

}

// Define the new web component
if ('customElements' in window) {
  customElements.define('smv-icon', SmvIcon);
}
